import React, { Component } from "react";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import {
  Card,
  CardBody,
  Col,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import Rates from "./Tabs/Rates";
import Services from "./Tabs/Services";
import FinalTab from "./Tabs/FinalTab";
import SpecialPacks from "./Tabs/SpecialPacks";

class ConfigSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "services",
    };
    this.toggleTab = this.toggleTab.bind(this);
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Col xs={12}>
            <Card>
              <CardHeader>
                <h5>Configurador Web</h5>
              </CardHeader>
              <CardBody>
                <Nav card justified pills>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab === "services"}
                      onClick={() => this.toggleTab("services")}
                      style={{
                        cursor:
                          this.state.activeTab !== "services"
                            ? "pointer"
                            : null,
                      }}
                    >
                      Servicios
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab === "rates"}
                      onClick={() => this.toggleTab("rates")}
                      style={{
                        cursor:
                          this.state.activeTab !== "rates" ? "pointer" : null,
                      }}
                    >
                      Tarifas
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab === "finalTab"}
                      onClick={() => this.toggleTab("finalTab")}
                      style={{
                        cursor:
                          this.state.activeTab !== "finalTab"
                            ? "pointer"
                            : null,
                      }}
                    >
                      Vista Final
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab === "specialPacks"}
                      onClick={() => this.toggleTab("specialPacks")}
                      style={{
                        cursor:
                          this.state.activeTab !== "specialPacks"
                            ? "pointer"
                            : null,
                      }}
                    >
                      Packs especiales
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="services">
                    {this.state.activeTab === "services" && <Services />}
                  </TabPane>
                  <TabPane tabId="rates">
                    {this.state.activeTab === "rates" && <Rates />}
                  </TabPane>
                  <TabPane tabId="finalTab">
                    {this.state.activeTab === "finalTab" && <FinalTab />}
                  </TabPane>
                  <TabPane tabId="specialPacks">
                    {this.state.activeTab === "specialPacks" && (
                      <SpecialPacks />
                    )}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    );
  }
}

export default ConfigSetup;



// WEBPACK FOOTER //
// ./src/views/Configurator/ConfigSetup.jsx